var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBold(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8125 11.4688C16.5312 10.7812 17 9.84375 17 8.75C17 6.6875 15.3125 5 13.25 5H7.5C7.21875 5 7 5.25 7 5.5V6C7 6.28125 7.21875 6.5 7.5 6.5H8V17.5H7.5C7.21875 17.5 7 17.75 7 18V18.5C7 18.7812 7.21875 19 7.5 19H14C16.1875 19 18 17.2188 18 15C18 13.4688 17.0938 12.1562 15.8125 11.4688ZM10 6.5H12.75C13.9688 6.5 15 7.53125 15 8.75C15 10 13.9688 11 12.75 11H10V6.5ZM13.5 17.5H10V12.5H13.5C14.875 12.5 16 13.625 16 15C16 16.4062 14.875 17.5 13.5 17.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBold);
export default __webpack_public_path__ + "static/media/bold.041fa877e3b0439bb96210c4645bb4e1.svg";
export { ForwardRef as ReactComponent };